import * as React from 'react';
import { LProps, withLocalization } from '../../utils/wrappers';
import { compose } from 'redux';
import { State } from '../../redux/state';
import { connect } from 'react-redux';
import { DataURLFromFile, getDataURLFromFileInput } from '../../utils/image';

export const PHOTO_ACCEPT =
  '.heic,.heif,.jpg,.jpeg,.png,.gif,.webp,image/heic,image/heif,image/jpeg,image/png,image/gif,image/webp';
export const VIDEO_ACCEPT =
  '.mp4,.mov,.m4v,.avi,.webm,video/mp4,video/quicktime,video/webm,video/avi,video/mpeg,video/*';
export const MEDIA_ACCEPT = `${PHOTO_ACCEPT},${VIDEO_ACCEPT}`;

interface ManualProps {
  id: string;
  disabled?: boolean;
  accept?: string;
  ariaLabel?: string;
  onChange: (dataURLFromFile: DataURLFromFile) => void;
  onError?: (err: Error) => void;
}

class ImageInput extends React.Component<LProps<ManualProps>> {
  public state = { dataURL: '' };

  private async onChange() {
    const { onChange, onError } = this.props;
    try {
      const dataURLFromFile = await getDataURLFromFileInput(this.props.id);
      if (!dataURLFromFile) return;
      onChange(dataURLFromFile);
    } catch (err) {
      if (onError) {
        onError(err instanceof Error ? err : new Error(String(err)));
      }
    }
  }

  public render() {
    const {
      id, disabled = false, accept = MEDIA_ACCEPT, ariaLabel, t
    } = this.props;
    return (
      <input
        id={id}
        aria-label={ariaLabel || `video/photo upload ${id}`}
        disabled={disabled}
        type="file"
        onChange={() => this.onChange()}
        // Separate photo vs video pickers avoid iOS Photos handing back a Live Photo still.
        accept={accept}
        style={{ position: 'absolute', left: '-999999px' }}
      />
    );
  }
}

const mapStateToProps = (_state: State, _ownProps: Partial<ManualProps>): Partial<ManualProps> => ({});

export default compose(
  withLocalization('imageUploader'),
  connect(mapStateToProps)
)(ImageInput) as React.SFC<ManualProps>;
